import request from '@/utils/request';
const path = 'promotion/report/jrtt';

/**
 * 获取广告转化图表接口
 * @param {Object} data 参数
 * @returns
 */
export function getPromotionConvertReportApi(data) {
  return request({
    url: `${path}/convert`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取广告平台图表接口
 * @param {Object} data 参数
 * @returns
 */

export function getPromotionPlatformReportApi(data) {
  return request({
    url: `${path}/platform`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取广告报表接口
 * @param {Object} data 参数
 * @returns
 */
export function getPromotionTableReportApi(data) {
  return request({
    url: `${path}/table`,
    method: 'GET',
    params: data,
  });
}
